const equality = `In Finland, people believe in treating everyone equally and with fairness. 
They understand that everyone is different and that's okay. 
They want to make sure that everyone has the same opportunities and rights.
It's important that everyone, no matter who they are, feels safe and respected. 
People in Finland work to make sure that no one is treated differently because of things like their skin color, culture, or where they come from. 
They believe that everyone should have the same chances in life.
In Finland, women and men have the same rights and can do the same jobs. 
It's important that everyone gets the same pay for the same work. 
People also work to make sure that people with disabilities have the same access to things like schools and buildings. 
They want to make sure that everyone can live their lives with freedom and dignity.
Overall, it's great to see that people in Finland care about equality and fairness. 
They work to make sure that everyone feels like they belong and are valued.
It's important to keep working towards a world where everyone is treated with respect and kindness.`;

export default equality;